import axios from 'axios'
import { useState } from 'react'
import { constants } from '../../Constants'
import { Button, Modal } from '../ui'
import { useToast } from '../ui/Toast/Toast'

export const ModalForceChangePassword = ({ user, onPasswordChanged }) => {
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const toast = useToast()

  const evaluateStrength = pw =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$.!%*#?&]{8,}$/.test(pw)
      ? 'Fuerte'
      : 'Débil'

  const handleChangePassword = async () => {
    if (!newPassword || newPassword !== confirmPassword) {
      toast({
        title: 'Error',
        description: 'Las contraseñas no coinciden o están vacías.',
        status: 'error',
      })
      return
    }
    if (evaluateStrength(newPassword) === 'Débil') {
      toast({
        title: 'Contraseña débil',
        description:
          'Debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número.',
        status: 'error',
      })
      return
    }
    setLoading(true)
    try {
      const response = await axios.put(`${constants.urlLocal}change-password`, {
        userId: user.id,
        newPassword,
      })
      if (response.data.message) {
        // Actualizar el usuario en localStorage para quitar el flag
        const storedUser = JSON.parse(localStorage.getItem('user'))
        if (storedUser) {
          storedUser.mustChangePassword = false
          localStorage.setItem('user', JSON.stringify(storedUser))
        }
        toast({
          title: 'Contraseña actualizada',
          description: 'Tu contraseña ha sido cambiada con éxito.',
          status: 'success',
        })
        onPasswordChanged()
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo cambiar la contraseña. Inténtalo de nuevo.',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  // No se puede cerrar esta modal — sin onClose ni botón cancelar
  return (
    <Modal
      isOpen={true}
      onClose={() => {}}
      closable={false}
      title="🔒 Debes cambiar tu contraseña"
    >
      <p style={{ marginBottom: '1rem', color: '#555', fontSize: '0.9rem' }}>
        Has recibido una contraseña temporal. Por seguridad, establece una nueva
        contraseña antes de continuar.
      </p>

      <div className="form-group">
        <label className="form-label">Nueva contraseña</label>
        <input
          className="form-input"
          type={showPassword ? 'text' : 'password'}
          placeholder="Introduce la nueva contraseña"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
        />
        {newPassword && (
          <p
            style={{
              fontSize: '0.8rem',
              color:
                evaluateStrength(newPassword) === 'Fuerte'
                  ? '#28a745'
                  : '#dc3545',
              marginTop: '0.25rem',
            }}
          >
            Seguridad: {evaluateStrength(newPassword)}
          </p>
        )}
      </div>

      <div className="form-group">
        <label className="form-label">Confirmar contraseña</label>
        <input
          className="form-input"
          type={showPassword ? 'text' : 'password'}
          placeholder="Repite la contraseña"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
        />
      </div>

      <label className="form-checkbox" style={{ marginBottom: '1rem' }}>
        <input
          type="checkbox"
          checked={showPassword}
          onChange={() => setShowPassword(!showPassword)}
        />
        Mostrar contraseña
      </label>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="primary"
          onClick={handleChangePassword}
          disabled={loading}
        >
          {loading ? 'Guardando...' : 'Cambiar contraseña'}
        </Button>
      </div>
    </Modal>
  )
}
